const TWELVE_DATA_BASE_URL =
    process.env.REACT_APP_TWELVE_DATA_API_URL || 'https://api.twelvedata.com';
const TWELVE_DATA_API_KEY =
    process.env.REACT_APP_TWELVE_DATA_API_KEY?.trim() || '';
const NORMALIZED_TWELVE_DATA_BASE_URL = TWELVE_DATA_BASE_URL.replace(/\/$/, '');

const intervalMap = {
    '1m': '1min',
    '5m': '5min',
    '15m': '15min',
    '30m': '30min',
    '1H': '1h',
    '4H': '4h',
    '1D': '1day',
    '1W': '1week',
    '1M': '1month',
};

const request = async (endpoint, params = {}) => {
    if (!TWELVE_DATA_API_KEY) {
        throw new Error(
            'Missing REACT_APP_TWELVE_DATA_API_KEY in your .env file.'
        );
    }

    const normalizedEndpoint = endpoint.startsWith('/')
        ? endpoint
        : `/${endpoint}`;
    const url = new URL(
        `${NORMALIZED_TWELVE_DATA_BASE_URL}${normalizedEndpoint}`
    );
    url.searchParams.set('apikey', TWELVE_DATA_API_KEY);

    Object.entries(params).forEach(([key, value]) => {
        if (value) {
            url.searchParams.set(key, value);
        }
    });

    const response = await fetch(url);

    if (!response.ok) {
        throw new Error(`Twelve Data request failed: ${response.status}`);
    }

    const data = await response.json();

    if (data.status === 'error') {
        throw new Error(data.message || 'Twelve Data returned an error.');
    }

    return data;
};

export const twelveDataAPI = {
    hasApiKey: Boolean(TWELVE_DATA_API_KEY),

    getTimeSeries: async ({
        asset,
        interval,
        startDate,
        endDate,
        outputsize = 5000,
    }) =>
        request('/time_series', {
            symbol: asset?.symbol,
            exchange: asset?.exchange,
            interval: intervalMap[interval] || interval,
            start_date: startDate,
            end_date: endDate,
            outputsize,
            order: 'ASC',
        }),
};
